import {
  MESSAGE_SENDER,
  MESSAGE_TYPES,
  // BUTTON_SUB_TYPES,
  BUTTON_TYPES,
} from "./constants"

export const getDefaultMessagesByKey = (key = "web") => {
  const defaultMessgaes = {
    web: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        disableAfterUserReply: true,
        variable_name: "subscription",
        delay: 0,
        payload: {
          title: 'Please select the language to proceed further:',
          subtitle: 'الرجاء تحديد اللغة للاستمرار',
          buttons: [
            {
             type: BUTTON_TYPES.DEFAULT,
             text: "English",
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "العربية",
            },
          ],
        },
        timestamp: new Date(),
      },
        // inputType: "currency", // type = "currency/phone/date"
        // inputProps: {
        //   placeholder: "Enter salary",
        //   prefix: "₹",
        //   maxLength: 10,
        // },
    ],
    android: [
      {
        type: MESSAGE_TYPES.TEXT,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: false,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "",
        delay: 0,
        payload: {
          text: "Hi, I'm OriBot, Your Personal Virtual Assistant.",
        },
        timestamp: new Date(),
      },
      {
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "subscription",
        delay: 0,
        payload: {
          title: "",
          subtitle: "What can I help you with today?",
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Need a chatbot",
              url: "",
            },
            {
              type: BUTTON_TYPES.LINK,
              text: "About Us",
              url: "https://oriserve.com/about-us/",
            },
            {
              type: BUTTON_TYPES.LINK,
              text: "Convert",
              url: "https://oriserve.com/",
            },
            {
              type: BUTTON_TYPES.LINK,
              text: "GBM",
              url: "https://googlebizmessaging.oriserve.com/chatbots-google-business-messaging",
            },
            {
              type: BUTTON_TYPES.LINK,
              text: "Work with us",
              url: "https://oriserve.com/careers/",
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Connect with our team",
              url: "",
            },
          ],
        },
        timestamp: new Date(),
      },
    ],
    ar: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "subscription",
        disableAfterUserReply: true,
        delay: 0,
        payload: {
          title: 'Please select the language to proceed further:',
          subtitle: 'الرجاء تحديد اللغة للاستمرار',
          buttons: [
            {
             type: BUTTON_TYPES.DEFAULT,
             text: "English",
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "العربية",
            },
          ],
        },
        timestamp: new Date(),
      },
    ],
    en: [
      {
        cmid: "message3",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: "subscription",
        disableAfterUserReply: true,
        delay: 0,
        payload: {
          title: 'Please select the language to proceed further:',
          subtitle: 'الرجاء تحديد اللغة للاستمرار',
          buttons: [
            {
             type: BUTTON_TYPES.DEFAULT,
             text: "English",
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "العربية",
            },
          ],
        },
        timestamp: new Date(),
      },
    ],
  }
  return defaultMessgaes[key] || []
}